import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import Paper from "@/components/paper/Paper";
import { DataMasking } from "@/components/dataMasking/DataMasking";
import { DataMaskingComponentProperties } from "@/components/dataMasking/IDataMasking";
import { track_event, windowOnLoadOrImmediate } from "@/shared/FunctionCore";
import { addIfNotNull, createMinHeightClass, getMaxHeight, updateMinHeight } from "@/shared/Internal";
import "@/app/pages/companyProfile/topCompetitors/TopCompetitorsStyles.scss";

// type BusinessDirectoryTopCompetitorsComponentProperties = DataMaskingComponentProperties & {
// 	"companyNaicsIndustrytitle": string;
// 	"competitors": Competitor[];
// 	"properties": Properties;
// 	"seeMoreCompaniesInIndustryUrl": string;
// 	"unlockDetailedCompetitorProfilesUrl": string;
// };

type BusinessDirectoryTopCompetitorsComponentProperties = DataMaskingComponentProperties & {
	"competitorSize": number,
	"industryName": string,
	"industryUrl": string
}

type IcompetitorsProps = {
	"props": BusinessDirectoryTopCompetitorsComponentProperties
}

const TopCompetitors = ({ props }: IcompetitorsProps): JSX.Element => {
	const { t } = useTranslation();

	const {
		competitorSize,
		industryName,
		industryUrl
	} = props

	const businessDirectoryTopCompetitorsCompaniesWrapperReference = useRef<HTMLDivElement>(null);
	const businessDirectoryTopCompetitorsCompanyNameArrayReference = useRef<(HTMLDivElement)[]>([]);

	const [showScrollSwipeMessage, setShowScrollSwipeMessage] = useState(false);
	const [businessDirectoryTopCompetitorsCompanyNameMinHeight, setBusinessDirectoryTopCompetitorsCompanyNameMinHeight] = useState<number | undefined>();

	const maximumIndex = competitorSize - 1;
	const topCompetitorsHeaderText = "Top Competitors";

	useEffect(() => {
		const updateShowScrollSwipeMessage = () => {
			const current = businessDirectoryTopCompetitorsCompaniesWrapperReference.current;

			if (current !== null) {
				setShowScrollSwipeMessage(current.offsetWidth < current.scrollWidth);
			}
		};

		updateShowScrollSwipeMessage();

		const $window = $(window);

		$window.on("resize", updateShowScrollSwipeMessage);

		const setMinHeights = () => {
			updateMinHeight(getMaxHeight(businessDirectoryTopCompetitorsCompanyNameArrayReference), setBusinessDirectoryTopCompetitorsCompanyNameMinHeight);
		};

		setMinHeights();

		$(setMinHeights);
		windowOnLoadOrImmediate($window, setMinHeights);
	}, []);

	const scrollOrSwipeMessage = (swipe: boolean) =>
		<div
			className={classnames("businessDirectoryTopCompetitorsCompactMessage", {
				"showScrollSwipeMessage": showScrollSwipeMessage,
				"hideScrollSwipeMessage": !showScrollSwipeMessage,
				"swipe": swipe,
				"scroll": !swipe
			})}
		// className={
		// 	cx(
		// 		classCombiner(styles, "businessDirectoryTopCompetitorsCompactMessage"),
		// 		classCombiner(styles, showScrollSwipeMessage ? "showScrollSwipeMessage" : "hideScrollSwipeMessage"),
		// 		classCombiner(styles, swipe ? "swipe" : "scroll"))
		// }
		>
			{swipe ? "Swipe" : "Scroll"}

			{" "}
			to see more
		</div>;

	return competitorSize === 0 ? (
		<span
			dangerouslySetInnerHTML={{
				"__html": `
<!--
    Skipping top competitors component because company has no competitor data
-->`,
			}}
			style={{ "display": "none" }}
		/>
	) : (
		<>
			<a
				className="anchor businessDirectoryTopCompetitorsAnchor"
				data-name="top-competitors-anchor" />

			{/* <div className={`businessDirectoryTopCompetitorsComponent ${properties.properties.componentclass}`}>
				<div className="businessDirectoryTopCompetitorsHeader">
					{topCompetitorsHeaderText}
				</div> */}

			<Paper title="Top Competitors">
				<div className="businessDirectoryTopCompetitorsComponentLinksWrapper">
					<div className="businessDirectoryTopCompetitorsSeeMoreCompaniesInIndustryWrapper">
						<a
							className="businessDirectoryTopCompetitorsSeeMoreCompaniesInIndustryLink"
							href={`/business-directory${industryUrl}.html#top-companies-anchor`}>
							<span className="businessDirectoryTopCompetitorsSeeMoreCompaniesInIndustryText">
								See More Companies in the
								{" "}
								{industryName}
								{" "}
								Industry
							</span>
							&nbsp;
							<span className="businessDirectoryTopCompetitorsSeeMoreCompaniesInIndustryArrow" />
						</a>
					</div>

					<div className="businessDirectoryTopCompetitorsUnlockDetailedCompetitorProfilesWrapper">
						<a
							className="businessDirectoryTopCompetitorsUnlockDetailedCompetitorProfilesLink"
							href={t("companyProfile.unlockDetailedCompetitorProfilesUrl")}
							onClick={() => track_event("Unlock_detailed_competitor_profiles_clicked")}
						>
							<span className="businessDirectoryTopCompetitorsUnlockDetailedCompetitorProfilesImage" />
							&nbsp;
							<span className="businessDirectoryTopCompetitorsUnlockDetailedCompetitorProfilesText">
								Unlock detailed competitor profiles
							</span>
							&nbsp;
							<span className="businessDirectoryTopCompetitorsUnlockDetailedCompetitorProfilesArrow" />
						</a>
					</div>
				</div>

				<div
					className={classnames("businessDirectoryTopCompetitorsCompaniesWrapper", {
						"showScrollSwipeMessage": showScrollSwipeMessage,
						"hideScrollSwipeMessage": !showScrollSwipeMessage,
					})}
					// className={cx(
					// 	classCombiner(styles, "businessDirectoryTopCompetitorsCompaniesWrapper"),
					// 	showScrollSwipeMessage ? "showScrollSwipeMessage" : "hideScrollSwipeMessage",
					// 	classCombiner(styles, showScrollSwipeMessage ? "showScrollSwipeMessage" : "hideScrollSwipeMessage")
					// )}
					ref={businessDirectoryTopCompetitorsCompaniesWrapperReference}>
					{Array.from({ length:competitorSize ?? 0 }).map((_co, nu) => (
						<>
							<div className="businessDirectoryTopCompetitorsCompany">
								<div className="businessDirectoryTopCompetitorsNumber">
									<div className="businessDirectoryTopCompetitorsNumberStar" />

									<span className="businessDirectoryTopCompetitorsNumberText">
										No
										{nu + 1}
									</span>
								</div>

								<div className="businessDirectoryTopCompetitorsCompanyDetails">
									<div
										className={`businessDirectoryTopCompetitorsCompanyName ${createMinHeightClass(businessDirectoryTopCompetitorsCompanyNameMinHeight)}`}
										ref={addIfNotNull(businessDirectoryTopCompetitorsCompanyNameArrayReference)}>
										<span className="businessDirectoryTopCompetitorsCompanyNameLabel">
											Competitor Name:
										</span>
										&nbsp;
										<span className="businessDirectoryTopCompetitorsCompanyNameValue">
											<DataMasking hooversFreeTrialDirectoryPathRewritten={t("companyProfile.unlockDetailedCompetitorProfilesUrl")} />
										</span>
									</div>

									{
										// Suppressing display of revenue because the numbers in many cases don't match the revenue provided by the main company information API call
									}

									{/*
                                        {co.salesRevenue === 0 ? (
                                            <></>
                                        ) : (
                                            <div className={cx("businessDirectoryTopCompetitorsCompanyRevenue")}>
                                                <span className={cx(classCombiner(styles, "businessDirectoryTopCompetitorsCompanyRevenueImage"))} />
                                                <span className={cx(classCombiner(styles, "businessDirectoryTopCompetitorsCompanyRevenueLabel"))}>Revenue:</span>
                                                &nbsp;
                                                <span className={cx(classCombiner(styles, "businessDirectoryTopCompetitorsCompanyRevenueValue"))}>${co.formattedSalesRevenue}</span>
                                            </div>
                                        )}
                                    */}

									{/* }
                                        {co.individualEmployeeCount === 0 ? (
                                            <></>
                                        ) : (
                                            <div className={cx("businessDirectoryTopCompetitorsCompanyEmployees")}>
                                                <span className={cx(classCombiner(styles, "businessDirectoryTopCompetitorsCompanyEmployeesImage"))} />
                                                <span className={cx(classCombiner(styles, "businessDirectoryTopCompetitorsCompanyEmployeesLabel"))}>Employees:</span>
                                                &nbsp;
                                                <span className={cx(classCombiner(styles, "businessDirectoryTopCompetitorsCompanyEmployeesValue"))}>
                                                    {(() => {
                                                        const individualEmployeeCountString = co.individualEmployeeCount.toString();

                                                        const individualEmployeeCountStringLength = individualEmployeeCountString.length;
                                                        const individualEmployeeCountStringLengthMinusOne = individualEmployeeCountStringLength - 1;

                                                        let individualEmployeeCountStringWithCommas = "";

                                                        for (let i = 0; i < individualEmployeeCountStringLength; i += 1) {
                                                            const currentCharacter = individualEmployeeCountString.charAt(individualEmployeeCountStringLengthMinusOne - i);
                                                            const commaOrBlank = i > 0 && (i + 1) % 3 === 1 ? "," : "";

                                                            individualEmployeeCountStringWithCommas = currentCharacter + commaOrBlank + individualEmployeeCountStringWithCommas;
                                                        }

                                                        return individualEmployeeCountStringWithCommas;
                                                    })()}
                                                </span>
                                            </div>
                                        )}
                                        {*/}

									<div className="businessDirectoryTopCompetitorsCompanyEmployees">
										<span className="businessDirectoryTopCompetitorsCompanyEmployeesImage" />

										<span className="businessDirectoryTopCompetitorsCompanyEmployeesLabel">
											Employees:
										</span>
										&nbsp;
										<span
											className="businessDirectoryTopCompetitorsCompanyEmployeesValue"
											data-tracking-name={topCompetitorsHeaderText}>
											<DataMasking hooversFreeTrialDirectoryPathRewritten={t("companyProfile.unlockDetailedCompetitorProfilesUrl")} />
										</span>
									</div>
								</div>
							</div>

							{nu < maximumIndex ? <div className="businessDirectoryTopCompetitorsCompanyPadding" /> : <></>}
						</>
					))}
				</div>

				{scrollOrSwipeMessage(true)}

				{scrollOrSwipeMessage(false)}
			</Paper>
		</>
	);
};

export default TopCompetitors;
